import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 3rem 1.5rem;
  text-align: center;
  color: ${(p) => p.theme.textMuted};

  svg {
    color: ${(p) => p.theme.textMuted};
    opacity: 0.7;
  }

  h4 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: ${(p) => p.theme.textSecondary};
  }

  p {
    margin: 0;
    font-size: 0.875rem;
    max-width: 360px;
  }
`;

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
  <Wrap>
    {icon}
    <h4>{title}</h4>
    {description && <p>{description}</p>}
    {action}
  </Wrap>
);

export default EmptyState;
